/**
 * Reports a Calendly booking made from the chat's embedded scheduler to n8n
 * (`Dimension Chat - Meeting Booked`), which stamps the chat session and queues the AE's
 * Slack. The same browser-event approach as `notifyCalendlyScheduled` on
 * /dimension-vs-competition, so no Calendly API token is involved.
 */
const WEBHOOK_URL = process.env.NEXT_PUBLIC_N8N_MEETING_BOOKED_WEBHOOK_URL ?? ''

const reportChatMeetingBooked = async (payload: {
  sessionId: string
  eventUri: string | null
  inviteeUri: string | null
}) => {
  if (!WEBHOOK_URL || !payload.sessionId || !payload.eventUri) return

  try {
    await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // No `keepalive`: a JSON body needs a CORS preflight, which some browsers refuse for
      // keepalive requests. Calendly's confirmation stays in the dialog, so the page is open.
      body: JSON.stringify(payload),
    })
  } catch (error) {
    // Calendly still emails the AE, so a lost report only costs the Slack ping.
    console.error('Could not report the chat Calendly booking', error)
  }
}

/**
 * Records on the chat session that the customer opened the AE's Calendly from the chat (the
 * booking itself is reported by `reportChatMeetingBooked`). Same-origin and fire-and-forget:
 * it must never delay or break opening the scheduler.
 */
export const reportChatMeetingLinkClicked = (sessionId: string) => {
  if (!sessionId) return
  fetch(`/api/t/chat-calendly?s=${encodeURIComponent(sessionId)}`, {
    method: 'POST',
    keepalive: true,
  }).catch(() => {
    // Amplitude still has `Chat Quote - Meeting Link Clicked` (sent via segmentTrack).
  })
}

export default reportChatMeetingBooked
